export default [
  {
    header: 'Configuración',
    resource: 'Evaluador CE'
  },
  {
    title: 'Mantenimiento',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Empresas',
        route: 'empresas',
        action: 'menu',
        resource: 'Empresas'
      },
      {
        title: 'Fundos',
        route: 'fundos',
        action: 'menu',
        resource: 'Fundos'
      },
      {
        title: 'Etapas',
        route: 'etapas',
        action: 'menu',
        resource: 'Etapas'
      },
      {
        title: 'Evaluador',
        route: 'evaluadorce',
        action: 'menu',
        resource: 'Evaluador CE'
      },
    ],
  },
  {
    title: 'Usuarios',
    route: 'usuarios',
    icon: 'UserPlusIcon',
    action: 'menu',
    resource: 'Usuarios'
  },
]
